import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  defaultToastConfig,
  FavoritosModule,
  PerfilUsuarioModule,
  TOAST_CONFIG_TOKEN,
  ToastModule
} from 'govbr-lib';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AuthInterceptor } from '../components/login/auth.interceptor';
import { SharedModule } from '../shared/shared.module';
import { CoreRoutingModule } from './core-routing.module';
import { HomeComponent } from './home/home.component';
import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { locale } from 'moment';
import { MAT_DATE_LOCALE } from '@angular/material';

locale('pt-br')
// Módulo responsável pelo carregamento dos módulos principais da aplicação de que devem ser providos
// globalmente através de .forRoot() para toda a aplicação ou que devem ser carregados apenas uma única vez

@NgModule({
  declarations: [HomeComponent, CabecalhoComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    ToastModule.forRoot(defaultToastConfig),
    CoreRoutingModule,
    SharedModule,
    HttpClientModule,
    PerfilUsuarioModule,
    FavoritosModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {   //Configura os tempos das animações de aparecer, sumir e fechar o toast
      provide: TOAST_CONFIG_TOKEN,
      useValue: {
        animation: {
          fadeOut: 700,
          fadeIn: 600,
          close: 5000
        }
      }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
})
export class CoreModule { }
